module.exports = __webpack_public_path__ + "img/icon_document.6ae210b8.svg";